import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUser } from '@/lib/auth';

import { FormCardTextField } from './form/FormCardField';
import { FORM_FIELD_NAMES } from './form/OnboardingForm';
import { SectionHeader } from './Section';

export const OnboardingGoalsContext = () => {
  const { t } = useTranslation();

  const user = useUser();
  const isAdmin = user.membership.role === RoleEnum.admin;
  const isStaff = useIsStaffUser();

  return (
    <Stack spacing={12}>
      <SectionHeader i18nPath='shared.onboarding.goalsContext.description' />
      <FormCardTextField
        key='goal-context'
        formField={FORM_FIELD_NAMES.GOALS_CONTEXT}
        placeholder={t('shared.onboarding.goalsContext.placeholder')}
        disabled={!isAdmin && !isStaff}
      />
    </Stack>
  );
};
